import { distribution } from "../copy/sq";

export function DistributionBar({ succeeded, failed, total }: { succeeded: number; failed: number; total: number }) {
  const pct = total > 0 ? (succeeded / total) * 100 : 0;
  return (
    <div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-ink-100">
        <div
          className={`h-full rounded-full ${pct >= 85 ? "bg-signal-good" : pct >= 50 ? "bg-signal-warn" : "bg-signal-bad"}`}
          style={{ width: `${Math.min(100, Math.max(0, pct))}%` }}
        />
      </div>
      <div className="mt-1.5 flex justify-between text-xs text-ink-400">
        <span>{distribution.succeeded(succeeded)}</span>
        <span>{distribution.failed(failed)}</span>
      </div>
    </div>
  );
}
